export default "__VITE_ASSET__f199c54e__"